<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: "Cotizá tu plan ideal - OSFATUN",
    titleTemplate: null,
    // titleTemplate: "Osfatun - %s",
    htmlAttrs: {
      lang: "es-ES",
    },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "author", content: "OSFATUN" },
      {
        name: "description",
        content:
          "Cotizá y contratá en instantes tu plan de salud - OSFATUN es la Obra Social de los Trabajadores NODOCENTES de las Universidades Nacionales.",
      },
      {
        name: "keywords",
        content:
          "OSFATUN,Obra Social,NODOCENTES,Universidades Nacionales. Argentina, cartilla, prestadores",
      },
    ],
  },
};
</script>

<style>
@import "~bulma/css/bulma.css";
@import "assets/fonts-loader/main-loader.css";
* {
  margin: 0;
  padding: 0;
  font-family: "Gotham Rounded" !important;
}
html {
  background-color: #f4f4f4;
  /* behavior: "smooth"; */
  scroll-behavior: smooth;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  margin-right: 10px;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
